module.exports = __webpack_public_path__ + "static/media/eccomerce-img.09366e64.png";